const localeMetadata = [
    { code: "en", label: "English" },
    { code: "de", label: "Deutsch" },
    { code: "nl", label: "Nederlands" },
    { code: "sv", label: "Svenska" },
    { code: "fr", label: "Français" },
    { code: "es", label: "Español" },
    { code: "pt", label: "Português" },
    { code: "it", label: "Italiano" },
    { code: "ru", label: "Русский" },
    { code: "uk", label: "Українська" },
    { code: "pl", label: "Polski" },
    { code: "zh", label: "中文" },
    { code: "ja", label: "日本語" },
    { code: "ko", label: "한국어" }
];

const resources = localeMetadata.reduce((acc, locale) => {
    acc[locale.code] = { common: require(`./${locale.code}/common.json`) };
    return acc;
}, {});

const supportedLocales = localeMetadata.map(locale => locale.code);
const languageLabels = localeMetadata.reduce((acc, locale) => {
    acc[locale.code] = locale.label;
    return acc;
}, {});
const localeOrder = [...supportedLocales];
const namespaces = ["common"];
const defaultLocale = "en";

module.exports = {
    resources,
    supportedLocales,
    namespaces,
    defaultLocale,
    languageLabels,
    localeOrder,
    localeMetadata
};
